import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import SidebarSolicitante from '../Components/Sidebar/Sidebar';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import verificandoTokenSolicitante from '../../FuncoesGerais/VerificarTokenSolicitante';
import '../theme/solicitante-theme.css';
import './ajuda.css';

function AjudaSolicitante() {
    const history = useHistory();
    const [busca, setBusca] = useState('');
    const [secoesAbertas, setSecoesAbertas] = useState(new Set());

    useEffect(() => {
        const ok = async () => {
            const resultado = await verificandoApp('SOLICITANTE');
            if (!resultado) {
                history.push('/');
                return;
            }
            await verificandoTokenSolicitante(history);
        };
        ok();
    }, [history]);

    const secoes = [
        {
            id: 'inicio',
            titulo: 'Início e navegação',
            itens: [
                { titulo: 'Home', texto: 'É a sua tela principal. Aqui você vê a lista dos seus chamados em andamento (abertos). Você pode pesquisar por descrição, atualizar a lista e clicar em um chamado para ver os detalhes e o histórico do atendimento.' },
                { titulo: 'Menu lateral', texto: 'O menu à esquerda tem: Home (seus chamados), Chamado (abrir novo), Histórico (chamados já fechados) e, no rodapé, Ajuda, seu usuário e Sair. Use o ícone de seta para recolher ou expandir o menu.' },
                { titulo: 'Trocar de empresa', texto: 'Se você tem acesso a mais de uma empresa, no topo do menu aparece o nome da empresa atual. Clique nela para escolher outra empresa e trocar o contexto. Seus chamados e dados passam a ser da empresa selecionada.' },
            ]
        },
        {
            id: 'chamados',
            titulo: 'Chamados',
            itens: [
                { titulo: 'Abrir novo chamado', texto: 'No menu, clique em "Chamado" (ou no botão "Novo chamado" na Home). Preencha a descrição do problema ou dúvida, escolha o tipo e outros dados solicitados e envie. A equipe de atendimento receberá e dará sequência.' },
                { titulo: 'Ver meus chamados abertos', texto: 'Na Home você vê todos os seus chamados que ainda estão em atendimento. Clique em um chamado para abrir os detalhes: ver o que você informou, as respostas da equipe, comentários e o status atual.' },
                { titulo: 'Histórico de chamados', texto: 'No menu, "Histórico" mostra os chamados já encerrados. Útil para relembrar como um problema foi resolvido ou consultar uma solução anterior.' },
            ]
        },
        {
            id: 'conta',
            titulo: 'Sua conta',
            itens: [
                { titulo: 'Usuário e senha', texto: 'No rodapé do menu, "Usuário" leva à tela de alterar sua senha. Use para trocar a senha de acesso ao sistema com segurança. É importante usar uma senha forte e que só você conheça.' },
            ]
        },
        {
            id: 'assistente',
            titulo: 'Assistente (IA)',
            itens: [
                { titulo: 'Chat com o assistente', texto: 'Quando sua empresa tiver o recurso habilitado, um assistente virtual aparece na tela. Você pode fazer perguntas sobre como usar o sistema, dúvidas sobre seus chamados ou pedir orientações. O assistente usa informações da base de conhecimento para responder.' },
            ]
        },
    ];

    const textoParaBusca = (s) => (s || '').toLowerCase().normalize('NFD').replace(/\p{Mc}/gu, '');
    const filtrado = busca.trim() === ''
        ? secoes
        : secoes.map(sec => ({
            ...sec,
            itens: sec.itens.filter(
                i => textoParaBusca(i.titulo).includes(textoParaBusca(busca)) ||
                    textoParaBusca(i.texto).includes(textoParaBusca(busca))
            )
        })).filter(sec => sec.itens.length > 0);

    const toggleSecao = (id) => {
        setSecoesAbertas(prev => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };

    return (
        <div className="app-layout">
            <SidebarSolicitante />
            <main className="main-content sol-page ajuda-main">
                <div className="ajuda-container">
                    <header className="ajuda-header">
                        <h1><i className="fas fa-question-circle" /> Ajuda</h1>
                        <p className="ajuda-intro">Aqui você encontra explicações sobre as funções do sistema para solicitantes. Use a busca para localizar um assunto.</p>
                        <div className="ajuda-busca">
                            <i className="fas fa-search ajuda-busca-icone" />
                            <input
                                type="text"
                                className="ajuda-busca-input"
                                placeholder="Buscar na ajuda (ex.: chamado, histórico, senha...)"
                                value={busca}
                                onChange={(e) => setBusca(e.target.value)}
                                aria-label="Buscar na ajuda"
                            />
                        </div>
                    </header>
                    <div className="ajuda-secoes">
                        {filtrado.length === 0 ? (
                            <p className="ajuda-sem-resultado">Nenhum resultado encontrado para &quot;{busca}&quot;. Tente outros termos.</p>
                        ) : (
                            filtrado.map(sec => {
                                const aberto = secoesAbertas.has(sec.id);
                                return (
                                    <section key={sec.id} className={`ajuda-painel ${aberto ? 'ajuda-painel--aberto' : 'ajuda-painel--fechado'}`} id={sec.id}>
                                        <button
                                            type="button"
                                            className="ajuda-painel-cabecalho"
                                            onClick={() => toggleSecao(sec.id)}
                                            aria-expanded={aberto}
                                            aria-controls={`ajuda-painel-conteudo-${sec.id}`}
                                            id={`ajuda-painel-cabecalho-${sec.id}`}
                                        >
                                            <span className="ajuda-painel-titulo">{sec.titulo}</span>
                                            <span className="ajuda-painel-icone" aria-hidden="true"><i className={`fas fa-chevron-${aberto ? 'up' : 'down'}`} /></span>
                                        </button>
                                        <div
                                            id={`ajuda-painel-conteudo-${sec.id}`}
                                            className="ajuda-painel-conteudo"
                                            role="region"
                                            aria-labelledby={`ajuda-painel-cabecalho-${sec.id}`}
                                        >
                                            <ul className="ajuda-lista">
                                                {sec.itens.map((item, idx) => (
                                                    <li key={idx} className="ajuda-item">
                                                        <strong className="ajuda-item-titulo">{item.titulo}</strong>
                                                        <p className="ajuda-item-texto">{item.texto}</p>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </section>
                                );
                            })
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
}

export default AjudaSolicitante;
